'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuConfig = [[[_config2.default.routes.home, 'Home', 'l'], [_config2.default.routes.about, 'About us', 'l'], [_config2.default.routes.howitworks, 'How it works', 's'], [_config2.default.routes.faq, 'FAQs', 's'], [_config2.default.routes.media, 'Media', 's'], [_config2.default.links.contact, 'Contact us', 's'], [_config2.default.routes.legal, 'Legal disclaimer', 's'], [_config2.default.routes.companies, 'Deforestation-risk companies', 'l']], [[_config2.default.routes.clean, 'Search funds', 'l', 'search'], [_config2.default.routes.indexfunds, 'Index funds', 's'], [_config2.default.routes.targetdate, 'Target date funds', 's'], [_config2.default.routes.families, 'Fund managers', 'l'], [_config2.default.routes.families + '?q=Vanguard', 'Vanguard', 's'], [_config2.default.routes.families + '?q=BlackRock%2FiShares', 'BlackRock/iShares', 's'], [_config2.default.routes.families + '?q=State%20Street', 'State Street', 's'], [_config2.default.routes.families, 'More fund managers', 's']], [[_config2.default.routes.toolkit, '#DefundDeforestation action toolkit', 'l'], [_config2.default.links.signup, 'Sign up', 'l', 'envelope-o'], [_config2.default.links.donate, 'Donate to As You Sow', 'l', 'heart']]];

exports.default = MenuConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuConfig/MenuConfig.js
// module id = 1323
// module chunks = 0